<template>
  <div class="ac2" style="width: 100%">
    <!-- banner -->
    <div class="banner" style="width: 100%">
      <img src="/imgs/ct.jpg" style="width: 100%" />
    </div>
    <!-- 顶宽布局 -->
    <div class="container">
      <!-- 标题 -->
      <div class="a2-title">
        <h3>关于我们</h3>
        <div class="blink"></div>
      </div>
      <!-- 容器 -->
      <div class="a2-con">
        <div class="a2-l">
          <div class="a2-box">
            <p>
              北京哆啦音乐文化有限公司成立于2019年02月26日，注册地位于北京市东城区朝阳门北大街8号2号楼11层2-1，经营范围包括一般项目：组织文化艺术交流活动；电影摄制服务；广告发布；广告设计、代理；广告制作；会议及展览服务；社会经济咨询服务；建筑材料销售；日用品销售；
            </p>
            <p>
              工艺美术品及礼仪用品销售（象牙及其制品除外）；教育咨询服务（不含涉许可审批的教育培训活动）；摄影扩印服务；企业形象策划；文艺创作；文化用品设备出租；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；专业设计服务；影视美术道具置景服务；项目策划与公关服务。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）
            </p>
            <p>
              许可项目：演出经纪；电影发行；网络文化经营；出版物零售；出版物批发；广播电视节目制作经营；第二类增值电信业务；音像制品制作；营业性演出。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）（不得从事国家和本市产业政策禁止和限制类项目的经营活动。）
            </p>
          </div>
        </div>
        <div class="a2-r"></div>
      </div>
      <!-- 文本区 -->
      <div class="a2-info">


        <!-- 价值观 -->
        <div class="a2-item">
          <h3>联系我们:</h3>
          <p>公司名称：北京哆啦音乐文化有限公司</p>
          <p>联系电话：87497900</p>
          <p>联系邮箱：lixu@duolamusic.com</p>
          <p>网站域名：doramusic.cn</p>
          <p>公司地址：北京市东城区朝阳门北大街8号2号楼11层2-1</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";

export default {
  name: "ac1",
  components: {},
  data() {
    return {};
  },
  mounted() {
    document.title = "北京哆啦音乐文化有限公司";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.ac2 {
  .banner {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
    margin-top: 80px;
  }

  .container {
    // height: 1000px;
    margin: 60px auto;
    padding-top: 30px;
    box-sizing: border-box;

    // 标题
    .a2-title {
      text-align: center;

      h3 {
        font-size: 21px;
        color: #00bfb0;
      }

      .blink {
        width: 250px;
        height: 1px;
        background-color: #00bfb0;
        margin: 5px auto;
      }
    }

    // 容器
    .a2-con {
      width: 100%;
      height: 500px;
      //   background-color: pink;
      box-sizing: border-box;
      @include flex();

      // 左侧
      .a2-l {
        width: 50%;
        height: 100%;
        // background-color: red;
        position: relative;

        .a2-box {
          width: 80%;
          height: 85%;
          background-color: #4b80b7;
          position: absolute;
          right: 0;
          top: 50px;
          color: #fff;
          padding: 20px;
          box-sizing: border-box;

          p {
            font-size: 14px;
            margin: 30px auto;
          }
        }
      }

      // 右侧
      .a2-r {
        width: 50%;
        height: 100%;
        // background-color: yellow;
        background: url("/imgs/us.jpg") no-repeat center;
        background-size: cover;
      }
    }

    // 文本区
    .a2-info {
      .a2-item {
        margin-bottom: 60px;

        h3 {
          font-size: 24px;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          margin: 10px auto;
        }
      }
    }
  }
}</style>
